"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPanelLayout = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const UserPanelSidebarView_1 = require("./UserPanelSidebarView");
const __1 = require("../..");
const LogoWrap = app_1.styled.div `
  ${(theme) => theme.flexCenter};
  padding: ${(theme) => theme.spacing.small};
  position: relative;
`;
const StyledGrid = (0, app_1.styled)(ui_1.Grid) `
  * {
    font-family: 'DM Sans', sans-serif;
  }

  height: 100vh;
  overflow: hidden;

  h1,
  h2,
  h3 {
    color: black;
  }

  @media ${app_1.mobile} {
    grid-template-columns: 1fr;
    padding: 0 ${(theme) => theme.spacing.extraSmall};
  }
`;
const StyledSection = (0, app_1.styled)(ui_1.Section) `
  max-width: 100% !important;
  height: 100%;
`;
const IconStyle = (0, app_1.css) `
  display: none;
  color: ${(theme) => theme.colors.gray};
  cursor: pointer;

  @media ${app_1.mobile} {
    display: block;
    position: absolute;
    left: ${(theme) => theme.spacing.extraSmall};
    z-index: 2;
  }
`;
const OpenIcon = (0, app_1.styled)(svg_1.SvgMenu) `
  ${IconStyle}
`;
const CloseIcon = (0, app_1.styled)(svg_1.SvgCloseMenu) `
  ${IconStyle}
`;
const StyledStack = (0, app_1.styled)(ui_1.Stack) `
  @media ${app_1.mobile} {
    ${ui_1.Stack.variables.spacing}: 0rem;
  }
`;
function UserPanelLayout({ children, logo: Logo, }) {
    const [open, setOpen] = (0, react_1.useState)(false);
    const { user, loading } = (0, __1.useAuth)();
    const { push } = (0, app_1.useRouter)();
    const signInPath = (0, app_1.useContextPath)('signIn');
    const ecomPath = (0, app_1.useContextPath)('ecommerce');
    (0, react_1.useEffect)(() => {
        if (!loading && !user) {
            void push(signInPath);
        }
    }, [loading, push, signInPath, user]);
    if (loading || !user) {
        return (0, jsx_runtime_1.jsx)(ui_1.LoadingGlobal, {});
    }
    return ((0, jsx_runtime_1.jsxs)(StyledGrid, Object.assign({ templateColumns: "23rem minmax(0, 1fr)" }, { children: [(0, jsx_runtime_1.jsx)(UserPanelSidebarView_1.UserPanelSidebarView, { open: open, user: user }), (0, jsx_runtime_1.jsx)(StyledSection, Object.assign({ outerCss: (0, app_1.css) `
          overflow: auto;
          > div {
            padding-top: 0;
          }
        ` }, { children: (0, jsx_runtime_1.jsxs)(StyledStack, Object.assign({ kind: "vertical", divider: true }, { children: [(0, jsx_runtime_1.jsxs)(LogoWrap, { children: [open ? ((0, jsx_runtime_1.jsx)(CloseIcon, { onClick: () => setOpen(false) })) : ((0, jsx_runtime_1.jsx)(OpenIcon, { onClick: () => setOpen(true) })), (0, jsx_runtime_1.jsx)(app_1.Link, Object.assign({ href: ecomPath }, { children: (0, jsx_runtime_1.jsx)(Logo, {}) }))] }), children] })) }))] })));
}
exports.UserPanelLayout = UserPanelLayout;
